import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';

const columns = [
  {
    accessorKey: 'type',
    header: 'Expense Type',
    meta: {
      headerProps: { className: 'pe-1 fw-medium text-900' }
    }
    // cell: ({ row: { original } }) => {
    //   const { title } = original;
    //   return <Link to={paths.courseDetails()}>{title}</Link>;
    // }
  },
  {
    accessorKey: 'details',
    header: 'Details',
    meta: {
      headerProps: {
        className: 'pe-7 fw-medium text-900'
      }
    }
  },
  {
    accessorKey: 'estimatedCost',
    header: 'Estimated Cost',
    meta: {
      headerProps: {
        className: 'text-end fw-medium text-900'
      },
      cellProps: {
        className: 'text-end'
      }
    }
  },
  {
    accessorKey: 'none',
    header: '',
    enableSorting: false,
    meta: {
      cellProps: {
        className: 'text-end'
      }
    },
    cell: () => {
      return <Dropdown.Item href="#!">Edit</Dropdown.Item>;
    }
  }
];

const ExpenseBifurcationTable = ({ tableData }) => {
  const [data] = useState(tableData);
  const table = useAdvanceTable({
    data,
    columns,
    sortable: true
  });

  return (
    <AdvanceTableProvider {...table}>
      <AdvanceTable
        headerClassName="bg-200 text-nowrap align-middle font-sans-serif"
        rowClassName="btn-reveal-trigger text-nowrap align-middle"
        tableProps={{
          className: 'fs-10 fw-semibold mb-0 overflow-hidden'
        }}
      />
    </AdvanceTableProvider>
  );
};

ExpenseBifurcationTable.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ExpenseBifurcationTable;
